import styles from "./ShimmerLabel.module.css";

interface ShimmerLabelProps {
  readonly label: string;
}

export const ShimmerLabel = ({ label }: ShimmerLabelProps) => (
  <div key={label} className={styles.labelEnter}>
    <div className={`text-sm font-medium leading-5 ${styles.shimmerLabel}`}>
      {label}
    </div>
  </div>
);
